import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  backdrop: {
    backgroundColor: 'rgba(48, 85, 107, 0.2)',
  },
  searchButton: {
    backgroundColor: 'white',
    padding: 5,
  },
  searchInput: {
    '& .MuiOutlinedInput-root': {
      padding: '8px 12px !important',
    },
  },
}));
